export default "__VITE_ASSET__d4b2061d__"